import noop from 'lodash/noop';
import React, { useReducer, createContext, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import feedbackQuestionsReducer from '../reducers/feedbackQuestions';
import { getQuestions } from '../actions/question';
import UIContext from './UIState';

const FeedbackQuestionsContext = createContext({
  questions: [],
  dispatch: noop,
});

export const FeedbackQuestionsState = ({
  applicationId,
  feedbackIntent,
  children,
}) => {
  const [questions, dispatch] = useReducer(feedbackQuestionsReducer, []);
  const { dispatch: uiDispatch } = useContext(UIContext);

  useEffect(() => {
    if (applicationId && feedbackIntent) {
      getQuestions(applicationId, feedbackIntent)(dispatch, uiDispatch);
    }
  }, [applicationId, feedbackIntent]);

  return (
    <FeedbackQuestionsContext.Provider
      value={{
        questions,
        dispatch,
      }}>
      {children}
    </FeedbackQuestionsContext.Provider>
  );
};

FeedbackQuestionsState.propTypes = {
  applicationId: PropTypes.string.isRequired,
  feedbackIntent: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FeedbackQuestionsContext;
